/* eslint-disable */
export default {
  'en-US': {
    common: {
      NAME_HOLDER: "First name *",
      LAST_NAME_HOLDER: "Last name *",
      EMAIL_HOLDER: "Your email address *",
      PASS_HOLDER: "Enter your password *",
      REPEAT_PASS_HOLDER: "Repeat your password *",
      BUTTON_EMAIL_SIGN_UP: "Sign Up with Email",

      TERMS_AND_CONDITIONS: "Terms and Conditions",
      PRIVACY_POLICY: "Privacy Policy",

      NEWSLETTER_CONSENT: "I consent to receiving emails from Time Out about the latest news, events, offers and partner promotions",
      TERM_OF_USE: "I have read and accept the {{terms_and_conditions}} and {{privacy_policy}} of Time Out",
      TERM_OF_USE_WITH_NEWSLETTERS: "I have read and accept the {{terms_and_conditions}} and {{privacy_policy}} of Time Out, including opt-in to marketing communications",

      HEADER_TITLE: "Create a Time Out Account",
      JOIN_FB: "Join with Facebook",
      JOIN_TW: "Join with Twitter",
      JOIN_GG: "Join with Google",
      JOIN_EM: "Join with Email",
      ALREADY_HAVE: "Already have a Time Out account?",
      CREATE_ACCOUNT_LOG_IN: "Log In",

      SIGN_IN_TITLE: "Sign In",
      SIGN_IN_FB: "Sign In with Facebook",
      SIGN_IN_TW: "Sign In with Twitter",
      SIGN_IN_GG: "Sign In with Google",
      SIGN_IN_EM: "Sign In with Email",
      YOUR_EMAIL: "Your email address",
      YOUR_PASSWORD: "Your password",
      REMEMBER: "Remember me",
      FORGOT: "Forgot?",
      HAVE_ACCOUNT_YET: "Don't yet have a Time Out account?",
      JOIN_HERE: "Join here",
      ALMOST_THERE: "Almost there",

      FORGOT_HEADER: "Forgot your password?",
      FORGOT_SUBTITLE: "No problem. Just enter your email address below - we'll send you a link to reset it",
      SEND_LINK: "Reset my password",

      RECEIVE_EMAIL: "Thank you, if you have previously registered with us using this email address you'll receive an email shortly",
      MANAGE_ACCOUNT: "Manage your account",
      EDIT_DETAILS_HERE: "You can edit your account details here",
      FIRST_NAME: "First Name",
      LAST_NAME: "Last Name",
      SCREEN_NAME: "Screen Name",
      EMAIL: "Email",
      ACCOUNT_DETAILS: "Account details",
      PASSWORD: "Password",
      SAVE_CHANGES: "SAVE CHANGES",
      UPLOAD_PIC: "Upload a new profile picture",
      CHOOSE_PHOTO: "Choose a photo from your device. The maximum size is 2MB.",
      CLOSE_ACCOUNT: "Close my account",
      PASSWORD_BELOW: "You can change your password below",
      CURRENT_PASSWORD: "Current password",
      NEW_PASSWORD: "New password *",
      REPEAT_PASSWORD: "Repeat new password *",

      OOPS: "Oops,",
      ERROR_404_OCCURED: "an error occurred…",
      ERROR_404_INFO: "We have either moved the page or it no longer exists",
      ERROR_500_TITLE: "The server returned a ",
      SMTH_BROKEN: " Something is broken",
      INTERNAL_RED: "500 Internal Server Error",
      LET_KNOW_RED: "Please let us know",
      ERROR_500_INFO: "what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.",

      EMAIL_ERROR: "Please enter a valid email address",
      FIRST_NAME_ERROR: "Please enter your first name",
      LAST_NAME_ERROR: "Please enter your last name",
      TERM_OF_USE_ERROR: "You must agree to our terms of use",
      SIGN_IN_VALIDATION_ERROR: "Incorrect email or password - please try again",
      ACCOUNT_PASSWORDS_VALIDATION: "Passwords do not match",
      WAS_IT: "Was it something we did?",
      DELETE_ACCOUNT_TEXT: "We’re sorry you’re thinking of deleting your account. If there’s something that’s made you want to leave, ",
      DELETE_ACCOUNT: "Delete Account",
      CANCEL: "Cancel",

      UPDATE_PASSWORD: "Update your password",
      PASSWORD_UPDATE_SUCCESS: "Your password has been updated",
      ERROR_PASSWORD_LENGTH: "Password must contain between 6 and 64 characters",

      ERROR_MISSING_SITE_PARAMETER: "Missing required application parameter: site",
      ERROR_ALREADY_REGISTERED: "You are already registered using email signup. Please login using {{email}}",
    }
  }
}



// WEBPACK FOOTER //
// ./translations/en-US.js